<template>
  <div class="field">
    <h2>CREATE {{ name.toUpperCase() }} LINK</h2>
    <div class="frow gutters">
      <div class="col-md-1-2">
        <label
          class="label"
          for="linkTitle"
        >
          link title
        </label>
        <input
          id="linkTitle"
          v-model="linkTitle"
          class="input"
          name="linkTitle"
          type="text"
        >
      </div>
      <div
        v-if="items.length > 0"
        class="col-md-1-2"
      >
        <label class="label">
          {{ name }}
        </label>
        <div
          
          class="select"
        >
          <select v-model="selected">
            <option
              v-for="i in items"
              :key="i.id"
              :value="i"
            >
              {{ i.title }}
            </option>
          </select>
        </div>
      </div>
      <div
        v-else
        class="col-md-1-2"
      >
        <label
          class="label"
          for="linkUrl"
        >
          {{ name }} url
        </label>
        <input
          id="linkUrl"
          v-model="linkUrl"
          class="input"
          name="linkUrl"
          type="text"
        >
      </div>
      <div
        v-if="selected || linkUrl"
        class="frow row-start mt-20"
      >
        <button 
          class="button is-info"
          @click.prevent="$emit('insertLink', generatedLink)"
        >
          Insert {{ name }} Link
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkTool',
  props: {
    name: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: null,
      linkTitle: '',
      linkUrl: null,
    };
  },
  computed: {
    generatedLink() {
      if (this.selected) {
        return `<a href="#${this.name.toLowerCase()}-${this.selected.id}">${this.linkTitle}</a>`;
      }
      if (this.linkUrl) {
        return `<a href="${this.linkUrl}" target="_blank">${this.linkTitle}</a>`;
      }
      return '';
    },
  },
};
</script>
<style scoped lang="scss">

</style>
